import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import Content from './components/Content';
import CurrentContent from './components/CurrentContent';
import About from './components/About';
import Map from './components/Map';
import FormTab from './components/FormTab';

import { TimeProvider } from './contexts/TimeContext';

import {
    BrowserRouter as Router,
    Routes,
    Route
} from "react-router-dom";


function App() {
    return (
        <React.Fragment>
            <TimeProvider>
                <Router>
                    <Header />
                    <Routes>
                        <Route path="/" element={<Content />}/>
                        <Route path="/form" element={<FormTab />}/>
                        <Route path="/place/:id" element={<CurrentContent />} />
                        <Route path="/about" element={<About/>}/>
                        <Route path="/map" element={<Map />}/>
                    </Routes>
                    <Footer />
                </Router>
            </TimeProvider>
        </React.Fragment>
    );
}

export default App;
